import React from 'react';
import { motion } from 'framer-motion';

const servicesData = [
  {
    icon: '🛠️',
    title: 'Egyedi bútor gyártás',
    description: '3D tervezés és teljes körű kivitelezés maximális testreszabással.',
  },
  {
    icon: '📐',
    title: 'Lapszabászat',
    description: 'Modern CNC lapszabászat precíz méretekkel és gyors átfutással.',
  },
  {
    icon: '🏪',
    title: 'Bútor és lakberendezés',
    description: 'Szőnyeg, függöny, konyhai és háztartási eszközök széles választéka.',
  },
  {
    icon: '🚚',
    title: 'Szállítás és beépítés',
    description: 'Bútorszállítás, költöztetés és szakszerű beépítés egy helyen.',
  },
  {
    icon: '💡',
    title: 'Tanácsadás',
    description: 'Ingyenes konzultáció és tervezési javaslatok szakértőinktől.',
  },
  {
    icon: '🎨',
    title: 'Anyagválaszték',
    description: 'Minőségi bútorlap, élzárás és kiegészítők nagy választékban.',
  },
];

export default function Services() {
  return (
    <section className="py-16 md:py-24 bg-[var(--color-bg)]">
      <div className="mx-auto max-w-[var(--container-max)] px-4">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="text-sm font-semibold text-[var(--color-accent)] uppercase tracking-wider mb-3">
            Szolgáltatásaink
          </div>
          <h2 className="text-3xl md:text-4xl font-[var(--font-serif)] font-semibold text-[var(--color-text-primary)] tracking-tight mb-4">
            Amit biztosan kapsz tőlünk
          </h2>
          <p className="text-lg text-[var(--color-text-secondary)] max-w-2xl mx-auto">
            Teljes körű megoldás az egyedi bútor gyártástól a szállításig
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {servicesData.map((service, index) => (
            <motion.div
              key={index}
              initial={false}
              className="group bg-white rounded-2xl p-6 md:p-8 shadow-[var(--shadow-subtle)] md:hover:shadow-[var(--shadow-md)] md:hover:-translate-y-2 transition-all duration-200"
            >
              {/* Icon */}
              <div className="text-5xl mb-4">{service.icon}</div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-[var(--color-text-primary)] mb-3">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-[var(--color-text-secondary)] leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

